import React from 'react';
import { useTranslation } from 'react-i18next';
import Picture from './Picture';

const ROLE_LABELS = {
  overview: 'Overview',
  label: 'Label',
  energy_label: 'Energy label',
  promo: 'Promo',
  other: 'Other',
};

/**
 * The photos stacked behind a main image, as thumbnails on the photo stage. Clicking one shows it
 * in place of the main image; the record and its analyses stay those of the main picture.
 */
function PictureStack({ mainUrl, attachments, activeUrl, onSelect }) {
  const { t } = useTranslation();
  const items = [{ url: mainUrl, label: t('Main photo') }, ...attachments.map(attachment => ({
    url: attachment.url,
    label: t(ROLE_LABELS[attachment.role] ?? ROLE_LABELS.other),
  }))];

  return (
    <div className="absolute right-4 top-4 z-20 flex max-h-[calc(100%-2rem)] flex-col gap-2 overflow-y-auto">
      {items.map(item => {
        const active = item.url === activeUrl;
        return (
          <button
            key={item.url}
            type="button"
            onClick={() => onSelect(item.url)}
            aria-pressed={active}
            title={item.label}
            className={[
              'relative h-16 w-16 shrink-0 overflow-hidden rounded-xl border-2 bg-black/60 shadow-lg transition sm:h-20 sm:w-20',
              active ? 'border-amber-400' : 'border-white/30 opacity-80 hover:opacity-100',
            ].join(' ')}
          >
            <Picture pictureurl={item.url} className="h-full w-full object-cover" />
            <span className="absolute inset-x-0 bottom-0 truncate bg-black/60 px-1 py-0.5 text-[0.6rem] font-semibold uppercase tracking-wide text-white">
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}

export default PictureStack;
